import type { Configuration } from "@azure/msal-browser";
import { resolveConsoleAuthorityFromEnv, resolveConsoleRedirectUri } from "./msalEnv";
import { getConsoleConfig } from "../runtimeConfig";

/**
 * MSAL configuration for the console app registration.
 *
 * Copied from the product SPA's msalConfig (design.md section 11: copy, do not
 * import). Entra values come from console runtime config, loaded before this module
 * (build once, promote many).
 */
export function buildConsoleMsalConfig(): Configuration {
  const rc = getConsoleConfig();
  const authority = resolveConsoleAuthorityFromEnv({
    VITE_CONSOLE_ENTRA_AUTHORITY: rc.entraAuthority,
    VITE_CONSOLE_ENTRA_TENANT_ID: rc.entraTenantId,
  });
  if (!authority) {
    throw new Error(
      "Cortex Console sign-in is not configured. Set CORTEX_CONSOLE_ENTRA_TENANT_ID " +
        "on the console web app so /console-config.json carries the corporate tenant.",
    );
  }
  return {
    auth: {
      clientId: rc.entraClientId || "",
      authority,
      redirectUri: resolveConsoleRedirectUri(window.location.origin),
      postLogoutRedirectUri: resolveConsoleRedirectUri(window.location.origin),
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: true,
    },
  };
}

/**
 * The console API accepts one audience: the console app registration's own client id
 * (cortex_console_token_validator.resolve_console_client_id). An id token for this app
 * carries that audience and the `roles` claim the sign-in projects, so these are the
 * scopes the console signs in with - the same shape the product SPA uses.
 */
export const CONSOLE_LOGIN_SCOPES = ["openid", "profile", "email"];
